import { createReducer, on } from '@ngrx/store';
import { EmulatorState } from '../../../shared/models/state/Emulator';
import {clearEmulatorStateAction, flowEventAction} from '../actions/emulator.action';

const initialState: EmulatorState = {
    flowEvents: []
}

export const emulatorReducer = createReducer(
    initialState,
    on(flowEventAction, (state, { flowEvent }) => {
        return {
            ...state,
            flowEvents: [...state.flowEvents, flowEvent]
        }
    }),
    on(clearEmulatorStateAction, (state) => {
        return {
          ...state,
          flowEvents: []
        };
    })
);
